import { CheckSquare } from "@phosphor-icons/react";
import { BugStatus } from "shared/types/bug-report";
import { PickerItemProps } from "../../types";

export const BugStatusItem = ({ item, isSelected, onSelect }: PickerItemProps<BugStatus>) => {
  const getStatusColor = (status: BugStatus) => {
    switch (status) {
      case BugStatus.REPORTED:
        return "bg-blue-100 text-blue-700 border-blue-300";
      case BugStatus.IN_PROGRESS:
        return "bg-moss-primary/10 text-moss-primary border-moss-primary/30";
      case BugStatus.TESTING:
        return "bg-purple-100 text-purple-700 border-purple-300";
      case BugStatus.RESOLVED:
        return "bg-green-100 text-green-700 border-green-300";
      case BugStatus.CLOSED:
        return "bg-neutral-200 text-neutral-600 border-neutral-300";
      default:
        return "bg-gray-100 text-gray-700 border-gray-300";
    }
  };

  return (
    <button
      onClick={() => onSelect(item)}
      className={`w-full text-left px-3 py-2 rounded-md text-sm transition-colors hover:bg-brick-secondary-fine ${
        isSelected ? "bg-moss-primary/10 border border-moss-primary/30" : ""
      }`}
    >
      <div className="flex items-center gap-2">
        <CheckSquare className="h-4 w-4 text-neutral-secondary-mid" weight="duotone" />
        <div className={`px-2 py-1 rounded-md border text-xs font-medium flex items-center gap-1 ${getStatusColor(item)}`}>
          <div className="w-2 h-2 rounded-full bg-current" />
          {item}
        </div>
      </div>
    </button>
  );
};
